import React from 'react';
import {Table, Row, Spin, Popconfirm, Pagination, Progress, message} from 'antd';
import {asyncList, actions, asyncDelete, asyncCheck, asyncStop,asyncDeleteDeviceIndex} from './reducers';
import {connect} from 'react-redux';
import SearchForm from './search.js';
import Edit from './edit.js';
import moment from 'moment';


class DeviceIndex extends React.Component {
    state = {
        selectedRowKeys: [],
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.asyncList();
    }

    formatterNumber = value => {
        if (value === null) {
            return "--";
        }
        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }


    //  分页器改变数据处理
    handlePaginationChange = (current, pageSize) => {
        let pagination = {
            current,
            pageSize,
        };
        this.props.changePagination(pagination);
        this.props.asyncList();
    };


    // 删除
    delete = record => {
        const {devicePrefixName} = record;
        this.props.asyncDelete(devicePrefixName).then(
            () => {
                setTimeout(() => {
                    this.props.asyncList()
                }, 50)
            });
    }

    // 删除索引
    deleteDeviceIndex = record => {
        const {devicePrefixName} = record;
        this.props.asyncDeleteDeviceIndex(devicePrefixName).then(
            () => {
                setTimeout(() => {
                    this.props.asyncList()
                }, 50)
            });
    }


    // 检测
    check = record => {
        const {devicePrefixName} = record;
        this.props.asyncCheck(devicePrefixName).then((data) => {
            message.success('检测结果: ' + data);
            this.props.asyncList();
        });
    }

    // 停止
    stop = record => {
        const {devicePrefixName} = record;
        this.props.asyncStop(devicePrefixName).then(
            () => {
                setTimeout(() => {
                    this.props.asyncList()
                }, 200)
            });
    }


    // 编辑
    edit = record => {
        let {id} = record;
        this.props.changeCurrentSelectId(id);
        this.props.editShow();
    }

    // 操作按钮
    renderAction = (text, record) => {
        return (
            <div>
                <a href="javascript:;" onClick={() => this.edit(record)}>
                    继续生成
                </a>
                {(record.deviceIndexStatus === 1 || record.deviceIndexStatus === 3|| record.deviceIndexStatus === 9) && <span className="ant-divider"/>}
                {(record.deviceIndexStatus === 1 || record.deviceIndexStatus === 3|| record.deviceIndexStatus === 9) &&
                <Popconfirm
                    title='确认检测设备信息是否正确'
                    okText='确定'
                    cancelText='取消'
                    onConfirm={() => {
                        this.check(record);
                    }}>
                    <a href="javascript:;">检测设备</a>
                </Popconfirm>
                }

                {record.deviceIndexStatus != 0 && <span className="ant-divider"/>}
                {record.deviceIndexStatus != 0 &&
                <Popconfirm
                    title='确认删除设备信息'
                    okText='确定'
                    cancelText='取消'
                    onConfirm={() => {
                        this.deleteDeviceIndex(record);
                    }}>
                    <a href="javascript:;">删除设备</a>
                </Popconfirm>
                }
                
                {record.deviceIndexStatus != 0 && <span className="ant-divider"/>}
                {record.deviceIndexStatus != 0 &&
                <Popconfirm
                    title='确认删除记录'
                    okText='确定'
                    cancelText='取消'
                    onConfirm={() => {
                        this.delete(record);
                    }}>
                    <a href="javascript:;">删除</a>
                </Popconfirm>
                }

                {record.deviceIndexStatus === 0 && <span className="ant-divider"/>}
                {record.deviceIndexStatus === 0 &&
                <Popconfirm
                    title='确认停止生成'
                    okText='确定'
                    cancelText='取消'
                    onConfirm={() => {
                        this.stop(record);
                    }}>
                    <a href="javascript:;">停止</a>
                </Popconfirm>
                }
            </div>
        );
    };

    // 多选框Change
    onSelectChange = selectedRowKeys => {
        console.log(selectedRowKeys)
        this.props.deleteMulti(selectedRowKeys);
    }

    render() {
        let {list, uiStatus, pagination, deleteMultiData} = this.props;
        let {total, current, pageSize} = pagination;
        let totalPage = Math.ceil(total / pageSize);
        let {isLoading} = uiStatus;

        const rowSelection = {
            selectedRowKeys: deleteMultiData,
            onChange: this.onSelectChange,
        };

        // 表头
        const columns = [
            {
                title: '设备前缀名称',
                dataIndex: 'devicePrefixName',
                key: 'devicePrefixName',
            },
            {
                title: '完整前缀',
                dataIndex: 'deviceName',
                key: 'deviceName',
            },
            {
                title: '设备类型',
                dataIndex: 'deviceType',
                key: 'deviceType',
                render: text => {
                    if (text === 0) {
                        return '全部';
                    } else if (text === 1) {
                        return '安卓';
                    } else if (text === 2) {
                        return 'IOS';
                    }
                },
            },
            {
                title: '总数',
                dataIndex: 'total',
                key: 'total',
                render: text => {
                    return this.formatterNumber(text);
                },
            },
            {
                title: '总生成数(动态)',
                dataIndex: 'totalCurNum',
                key: 'totalCurNum',
                render: text => {
                    return this.formatterNumber(text);
                },
            },
            {
                title: '计划生成数',
                dataIndex: 'generateSize',
                key: 'generateSize',
                render: text => {
                    return this.formatterNumber(text);
                },
            },
            {
                title: '生成数(动态)',
                dataIndex: 'curNum',
                key: 'curNum',
                render: text => {
                    return this.formatterNumber(text);
                },
            },
            {
                title: '实际需要生成数',
                dataIndex: 'actNum',
                key: 'actNum',
                render: text => {
                    return this.formatterNumber(text);
                },
            },
            {
                title: '状态',
                dataIndex: 'deviceIndexStatus',
                key: 'deviceIndexStatus',
                render: text => {
                    if (text === 0) {
                        return '生成中';
                    } else if (text === 1) {
                        return '完成';
                    } else if (text === 2) {
                        return '删除索引数据';
                    } else if (text === 3) {
                        return '停止';
                    } else if (text === 9) {
                        return '异常';
                    }
                },
            },
            {
                title: '创建时间',
                dataIndex: 'createTime',
                key: 'createTime',
                render: text => {
                    return moment(text).format('MM-DD HH:mm:ss');
                },
            },
            {
                title: '更新时间',
                dataIndex: 'updateTime',
                key: 'updateTime',
                render: text => {
                    return moment(text).format('MM-DD HH:mm:ss');
                },
            },
            {
                title: '生成进度',
                dataIndex: 'curNum',
                key: 'rate',
                render: (text, record, index) => {
                    let rate = 0;
                    if (record.actNum > 0) {
                        rate = (text / record.actNum * 100).toFixed(1);
                    }
                    return <Progress percent={rate} status={record.deviceIndexStatus === 3 ? "exception" : "active"}/>;
                },
            },
            {
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                render: (text, record, index) => {
                    return this.renderAction(text, record, index);
                },
            },
        ];

        return (
            <div style={{marginBottom: '20px'}}>
                <Row style={{marginTop: '10px'}}>
                    <SearchForm {...this.props} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                    <Table
                        columns={columns}
                        dataSource={list}
                        defaultExpandAllRows={false}
                        rowSelection={rowSelection}
                        pagination={false}
                    />
                    <Row type="flex" justify="end">
                        <Pagination
                            style={{padding: '10px 10px'}}
                            size="small"
                            showQuickJumper
                            pageSize={pageSize}
                            current={current}
                            total={total}
                            showTotal={(total, range) =>
                                `共 ${total ? total : '0'} 条记录，每页 ${pageSize} 条，这是第 ${totalPage
                                    ? current + '/' + totalPage
                                    : '1'} 页`}
                            showSizeChanger
                            pageSizeOptions={['40', '80', '120']}
                            onShowSizeChange={this.handlePaginationChange}
                            onChange={this.handlePaginationChange}
                        />
                    </Row>
                    <Edit/>
                </Spin>
            </div>
        );
    }

}

const mapStateToProps = state => ({
    list: state.deviceIndex.list,
    pagination: state.deviceIndex.pagination,
    uiStatus: state.deviceIndex.uiStatus,
    deleteMultiData: state.deviceIndex.deleteMultiData,
});

const mapDispatchToProps = dispatch => ({
    asyncList: () => dispatch(asyncList()),
    asyncCheck: devicePrefixName => dispatch(asyncCheck(devicePrefixName)),
    asyncStop: devicePrefixName => dispatch(asyncStop(devicePrefixName)),
    asyncDelete: devicePrefixName => dispatch(asyncDelete(devicePrefixName)),
    asyncDeleteDeviceIndex: devicePrefixName => dispatch(asyncDeleteDeviceIndex(devicePrefixName)),
    editShow: () => dispatch(actions.changeUiStatus({isUpdateShow: true})),
    changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    deleteMulti: data => dispatch(actions.deleteMulti(data)),
    changePagination: data => dispatch(actions.changePagination(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeviceIndex);





// WEBPACK FOOTER //
// ./pages/assist/deviceIndex/index.js